/**
 * Tam sonuç sayfası adresi (WP 2.11, K-16): `/search#q=…&type=…&tag=…`. Sorgu URL PARÇASINDA (fragment) taşınır: sunucuya
 * gönderilmez, web sunucusu erişim günlüğüne düşmez, `Referer` ile sızmaz; paylaşılabilir ve sert yenilemede korunur.
 */
import { SEARCH_RECORD_TYPES, type SearchRecordType } from '@castinflow/shared';

export interface SearchPageState {
  q: string;
  type: SearchRecordType | null;
  tag: string | null;
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function searchPagePath(p: {
  q: string;
  type?: SearchRecordType | null;
  tag?: string | null;
}): string {
  const h = new URLSearchParams();
  h.set('q', p.q);
  if (p.type) h.set('type', p.type);
  if (p.tag) h.set('tag', p.tag);
  return `/search#${h.toString()}`;
}

/** URL parçasını güvenle çözer: bilinmeyen tip/etiket biçimi yok sayılır. */
export function parseSearchHash(hash: string): SearchPageState {
  const h = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  const q = (h.get('q') ?? '').slice(0, 400);
  const t = h.get('type');
  const tag = h.get('tag');
  return {
    q,
    type:
      t !== null && (SEARCH_RECORD_TYPES as readonly string[]).includes(t)
        ? (t as SearchRecordType)
        : null,
    tag: tag !== null && UUID_RE.test(tag) ? tag : null,
  };
}
